import { IFieldForm } from "pages/read-documents/model/IFieldForm";
import { formatCurrency } from "shared/utils";
import { IContract } from "shared/api/services/getContractNumbers.js";

export const fieldsGeneralDataContract = (
  data: IContract,
  idContract?: string,
  contractStatusOptions?: { id: number; name: string }[],
): IFieldForm[] => {
  return [
    {
      id: "itemFormContract",
      name: "contractNumber",
      type: "number",
      label: "Número de contrato:",
      placeholder: "Número de contrato",
      testId: "itemFormContract",
      isEnable: true,
      defaulValue: idContract || "-",
    },
    {
      id: "fechaServicios",
      name: "contractDateService",
      type: "datePicker",
      label: "Fecha de contrato:",
      placeholder: "",
      testId: "contractDateService",
      isEnable: false,
    },
    {
      id: "fechaInicioServicios",
      name: "contractStartDateService",
      type: "datePicker",
      label: "Fecha de inicio de contrato:",
      placeholder: "",
      testId: "contractStartDateService",
      isEnable: false,
      defaulValue: data?.contractStartAt || "-",
    },
    {
      id: "contractEndDateService",
      name: "contractEndDateService",
      type: "datePicker",
      label: "Fecha Fin de contrato:",
      placeholder: "",
      testId: "contractEndDateService",
      isEnable: false,
      defaulValue: data?.contractEndAt || "-",
    },
    {
      id: "itemTotalValue",
      name: "totalValue",
      type: "number",
      label: "Valor Total Contratado:",
      placeholder: "",
      testId: "itemTotalValue",
      isEnable: false,
      defaulValue: `$ ${formatCurrency(data?.totalValue ?? 0)}`,
    },
    {
      id: "itemformNit",
      name: "nitEntidad",
      type: "number",
      label: "Nit contratista:",
      placeholder: "",
      testId: "itemformNit",
      isEnable: false,
      defaulValue: data?.provider?.employerIdNumber || "-",
    },
    {
      id: "itemformProvider",
      name: "providerName",
      type: "text",
      label: "Razón Social Contratista:",
      placeholder: "",
      testId: "itemformProvider",
      isEnable: false,
      defaulValue: data?.provider?.name || "-",
    },
    {
      id: "itemformcdpNumber",
      name: "cdpNumber",
      type: "text",
      label: "Número de CDP del Contrato:",
      placeholder: "",
      testId: "itemformcdpNumber",
      isEnable: false,
      defaulValue: data?.cdpNumber || "-",
    },
    {
      id: "itemformAuditorName",
      name: "auditorName",
      type: "text",
      label: "Auditor supervisor del contrato:",
      placeholder: "",
      testId: "itemformAuditorName",
      isEnable: false,
      defaulValue: data?.auditorName || "-",
    },
    {
      id: "itemContractBalance",
      name: "contractBalance",
      type: "number",
      label: "Saldo Contrato:",
      placeholder: "",
      testId: "itemContractBalance",
      isEnable: false,
      defaulValue: `$ ${formatCurrency(data?.contractBalance ?? 0)}`,
    },
    {
      id: "itemContractObject",
      name: "contractObject",
      type: "text",
      label: "Objeto de contrato:",
      placeholder: "",
      testId: "itemContractObject",
      isEnable: false,
      defaulValue: data?.contractObject || "N/A",
    },
    {
      id: "itemContractStatus",
      name: "contractStatus",
      type: "Select",
      label: "Estado del contrato:",
      placeholder: "",
      testId: "itemContractStatus",
      isEnable: true,
      defaulValue: data?.state?.name || "-",
      options: contractStatusOptions || [],
    },
  ];
};
